// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"da4b5ba0","977":"ce821ba1"}[chunkId] + ".chunk.js";
};